import { faX } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { getIdImgByUserId } from '../../../../../../utils/requestsUtils/functionsRequests/user/userFunctions'
import LoadingSpinner from '../../../../../LoadingSpinner'
import ExpandedImage from '../../../../../VerifyId/SliderId/SliderIdCard/ExpandedImage/ExpandedImage'
import "./UsersINE.css"

type UsersINEProps = {
    id: string
    closeImage: (event: any) => void
}


const UsersINE = ({ id, closeImage }: UsersINEProps) => {

    const [loading, setLoading] = useState(false)
    const [noImage, setNoImage] = useState(false)
    const [url, setUrl] = useState("")

    const cacheKey = `INE_info_${id}`

    useEffect(() => {

        const getUrl = () => {
            getIdImgByUserId(id, "Front_id")
            .then(({ url, base64 }) => {
                setUrl(url)
                console.log("url", url)
                localStorage.setItem(cacheKey, JSON.stringify({ url: url, timeStamp: new Date().toISOString() }))
            }).catch((error) => {
                console.log("EEEE", error)
                setNoImage(true)
            }).finally(() => {
                setLoading(false)
            })
        }
        
        const obj = localStorage.getItem(cacheKey)
        if(obj){
            const { timeStamp, url } = JSON.parse(obj)

            const currentDate = moment();
            const datePicture = moment(timeStamp);

            const diffInMinutes = currentDate.diff(datePicture, 'minutes');

            if(diffInMinutes >= 60){
                getUrl()
            }else{
                setUrl(url)
                setLoading(false)
            }
        }else{
            getUrl()
        }

    }, [])

    
    if(loading){
        return(
            <div className="fixed-all-screen background-dark center flex-d-column">
                <LoadingSpinner fullPage={true} />
            </div>
        )
    }

    if(noImage){
        return(
            <div className="fixed-all-screen background-dark center flex-d-column">
               <p className="fs-24">{"No image"}</p>
                <div onClick={closeImage} className="center circle mt-20 pointer con-icon-close-id-img"> 
                    <FontAwesomeIcon icon={faX} className="fs-18 c-white" />
                </div>
            </div>
        )
    }

    return (
        //@ts-expect-error
        <ExpandedImage url={url} onClick={closeImage} isVideo={false} />
    )
}

export default React.memo( UsersINE )